import { MatDateFormats } from '@angular/material/core';

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
	parse: {
		dateInput: 'dd.MM.yyyy',
	},
	display: {
		dateInput: 'dd.MM.yyyy',
		monthYearLabel: 'MMMM yyyy',
		dateA11yLabel: 'dd.MM.yyyy',
		monthYearA11yLabel: 'MMMM yyyy',
	},
};
